<script setup lang="ts">
import { UISelect } from "@gohighlevel/ghl-ui";
import uniqueId from "lodash/uniqueId";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export type VerificationMode = "interactive" | "invisible";

const props = defineProps<{
  invisible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:invisible", value: boolean): void;
}>();

const { t } = useI18n();

const selectId = uniqueId("captcha-verification-mode-");

const options = computed(() => [
  { label: t("fields.customized.interactive"), value: "interactive" as const },
  { label: t("fields.customized.invisible"), value: "invisible" as const },
]);

const mode = computed<VerificationMode>(() =>
  props.invisible ? "invisible" : "interactive",
);

const handleChange = (value: VerificationMode) => {
  emit("update:invisible", value === "invisible");
};
</script>

<template>
  <div class="form-group">
    <div class="flex space-x-3">
      <span
        class="hl-text-input-label mb-1 block text-sm font-medium text-gray-700"
        >{{ t("fields.customized.verificationMode") }}</span
      >
    </div>
    <UISelect
      :id="selectId"
      :value="mode"
      :options="options"
      @update:value="handleChange"
    />
    <div v-if="invisible" class="mt-2 text-xs text-gray-500">
      {{ t("fields.customized.invisibleModeDescription") }}
    </div>
  </div>
</template>
